import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-help-dialog-theproject',
  templateUrl: './help-dialog-theproject.component.html',
  styleUrls: ['./help-dialog-theproject.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpDialogTheprojectComponent {

}
